<template>
  <div class="ddh-report">
    <div class="conf-report">
                            <p class="report-tit tit1">中国共产党第十九届中央委员会第一次全体会议公报</p>
                            <p class="report-tit margin1 tit1">（2017年10月25日中国共产党第十九届中央委员会第一次全体会议通过）</p>
                            <p class="margin1">中国共产党第十九届中央委员会第一次全体会议，于2017年10月25日在北京举行。</p>
                            <p class="margin1">出席全会的有中央委员204人，候补中央委员172人。中央纪律检查委员会委员列席会议。</p>
                            <p class="margin1">习近平同志主持会议并在当选中共中央委员会总书记后作了重要讲话。</p>
                            <p class="margin1">全会选举了中央政治局委员、中央政治局常务委员会委员、中央委员会总书记；根据中央政治局常务委员会的提名，通过了中央书记处成员，决定了中央军事委员会组成人员；批准了十九届中央纪律检查委员会第一次全体会议选举产生的书记、副书记和常务委员会委员人选。名单如下：</p>
                            <p class="margin1">一、中央政治局委员</p>
                            <p class="margin1">（按姓氏笔画为序）</p>
                            <p class="margin1">丁薛祥 习近平 王晨 王沪宁 刘鹤 许其亮 孙春兰（女） 李希 李强 李克强 李鸿忠 杨洁篪 杨晓渡 汪洋 张又侠 陈希 陈全国 陈敏尔 赵乐际 胡春华 栗战书 郭声琨 黄坤明 韩正 蔡奇</p>
                            <p class="margin1">二、中央政治局常务委员会委员</p>
                            <p class="margin1">习近平 李克强 栗战书 汪洋 王沪宁 赵乐际 韩正</p>
                            <p class="margin1">三、中央委员会总书记</p>
                            <p class="margin1">习近平</p>
                            <p class="margin1">四、中央书记处书记</p>
                            <p class="margin1">王沪宁 丁薛祥 杨晓渡 陈希 郭声琨 黄坤明 尤权</p>
                            <p class="margin1">五、中央军事委员会主席、副主席、委员</p>
                            <p class="margin1">主 席 习近平</p>
                            <p class="margin1">副主席 许其亮 张又侠</p>
                            <p class="margin1">委 员 魏凤和 李作成 苗华 张升民</p>
                            <p class="margin1">六、中央纪律检查委员会书记、副书记、常务委员会委员</p>
                            <p class="margin1">书 记 赵乐际</p>
                            <p class="margin1">副书记 杨晓渡 张升民 刘金国 杨晓超 李书磊 徐令义 肖培 陈小江</p>
                            <p class="margin1">常务委员会委员（按姓氏笔画为序）</p>
                            <p class="margin1">王鸿津 白少康 刘金国 李书磊 杨晓超 杨晓渡 肖培 邹加怡（女） 张升民 张春生 陈小江 陈超英 赵乐际 侯凯 姜信治 骆源 徐令义 凌激 崔鹏</p>
                        </div>
  </div>
</template>

<script>
export default {};
</script>
